import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './types';
import * as actions from './actions';
import { notificationService } from './effect';
import { toast } from 'react-toastify';

function* fetchNotificationsSaga(action) {
  try {
    const response = yield call(notificationService.getNotifications, action.payload);
    yield put(actions.fetchNotificationsSuccess(response));
  } catch (error) {
    yield put(actions.fetchNotificationsFailure(error.message));
  }
}

function* markNotificationReadSaga(action) {
  try {
    yield call(notificationService.markNotificationRead, action.payload);
    yield put(actions.markNotificationReadSuccess(action.payload));
    toast.success('Notification marked as read');
  } catch (error) {
    yield put(actions.markNotificationReadFailure(error.message));
  }
}

export function* notificationWatcher() {
  yield takeLatest(types.FETCH_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
  yield takeLatest(types.MARK_NOTIFICATION_READ_REQUEST, markNotificationReadSaga);
}
